import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D278 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">
        You're viewing D278 - Scripting & Programming Foundations
      </h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 13.20 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            This course isn’t as intimidating as the title suggests. I followed
            the zybooks for this course and completed all the activities,
            challenges, and participations. It’s a very simple course with
            minimal content. I had taken a C programming class back in 2018
            during my mechanical engineering diploma, so I remembered some of
            the basics.
          </p>
          <p>
            Make sure you understand the foundations well, as this will
            significantly impact how quickly you can code. I wouldn’t stress too
            much about this course, though. We aren’t actually coding, so when
            you start coding in later courses, you'll make foundational mistakes
            (like I did), and that’s when you’ll really absorb the concepts.
          </p>
          <p>
            Key points: focus on understanding compiled vs. interpreted
            languages and object-oriented programming. I took the PA after
            completing the zybooks, and I could have finished this course in
            maybe 4-6 hours. However, since it was my first course at WGU, I
            took longer to figure out how zybooks works, as well as the PA and
            OA requirements.
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};
export default D278;
